import React from 'react';

const DuplicateResolutionModal = ({ 
  isOpen, 
  questionModule, 
  existingCount, 
  onReplace, 
  onRename, 
  onCancel 
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: 'var(--standard-box-shadow)',
        minWidth: '450px',
        maxWidth: '550px'
      }}>
        <div style={{
          fontSize: '24px',
          color: '#f59e0b',
          textAlign: 'center',
          marginBottom: '12px'
        }}>
          ⚠
        </div>
        
        <h3 style={{
          margin: '0 0 16px 0',
          fontSize: '18px',
          fontWeight: '600',
          color: '#d97706',
          textAlign: 'center'
        }}>
          Duplicate Question Module Found
        </h3>
        
        <p style={{
          margin: '0 0 20px 0',
          fontSize: '14px',
          color: 'var(--text-color)',
          lineHeight: '1.5',
          textAlign: 'center'
        }}>
          A question module named <strong>"{questionModule}"</strong> already exists 
          with {existingCount} question{existingCount !== 1 ? 's' : ''}.
        </p>

        <p style={{
          margin: '0 0 24px 0',
          fontSize: '14px',
          color: 'var(--text-color)',
          lineHeight: '1.5',
          textAlign: 'center'
        }}>
          Would you like to replace the existing questions or choose a new name?
        </p>
        
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={onCancel}
            onKeyDown={handleKeyPress}
            style={{
              padding: '10px 16px',
              backgroundColor: '#f5f5f5',
              color: '#666',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={onRename}
            style={{
              padding: '10px 16px',
              backgroundColor: 'var(--color1)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Choose New Name
          </button>

          <button
            onClick={onReplace}
            style={{
              padding: '10px 16px',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Replace Existing
          </button>
        </div>
      </div>
    </div>
  );
};

export default DuplicateResolutionModal;
